module.exports = __webpack_public_path__ + "img/f76b6fa.png";